// The six security-agent documents asked in the wizard's Documentación step
// (Sí/No + date + photo). key/dateKey/photoKey are candidate form fields;
// shortLabel is the portal's compact name for each one.
export const SECURITY_DOCS = [
  {
    key: "up_to_date_portation",
    label: "Portación de armas al día",
    shortLabel: "Portación de armas",
    dateKey: "portation_expiration_date",
    dateLabel: "Fecha de vencimiento",
    isExpiry: true,
    photoKey: "portation_photo",
  },
  {
    key: "basic_course",
    label: "Curso Básico de Seguridad Privada",
    shortLabel: "Curso básico",
    dateKey: "basic_course_date",
    dateLabel: "Fecha de realización",
    isExpiry: false,
    photoKey: "basic_course_photo",
  },
  {
    key: "fingerprints",
    label: "Registro de Huellas Dactilares",
    shortLabel: "Huellas",
    dateKey: "fingerprints_expiration_date",
    dateLabel: "Fecha de vencimiento",
    isExpiry: true,
    photoKey: "fingerprints_photo",
  },
  {
    key: "psych_exam",
    label: "Examen Psicológico para Portación",
    shortLabel: "Examen psicológico",
    dateKey: "psych_exam_expiration_date",
    dateLabel: "Fecha de vencimiento",
    isExpiry: true,
    photoKey: "psych_exam_photo",
  },
  {
    key: "weapons_course",
    label: "Curso Teórico Práctico de Armas",
    shortLabel: "Curso de armas",
    dateKey: "weapons_course_date",
    dateLabel: "Fecha de realización",
    isExpiry: false,
    photoKey: "weapons_course_photo",
  },
  {
    key: "avsec_course",
    label: "Curso AVSEC",
    shortLabel: "Curso AVSEC",
    dateKey: "avsec_course_date",
    dateLabel: "Fecha de realización",
    isExpiry: false,
    photoKey: "avsec_course_photo",
  },
];
